<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" ref="dialog" persistent max-width="1500px">
      <UserChangeInformation ref="modalForm" lazy-validation :loadFlag="loadFlag" @ok="modalFormOk">
      </UserChangeInformation>
      <v-card v-show="true" flat>
        <v-row class="rowBtn">
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'登録'" :handlerClick="handleOk"></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import UserChangeInformation from "@/views/user/UserChangeInformation.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import { RyouTableMixins } from "@/mixins/RyouTableMixins";
  export default {
    name: "DormitoryUserDetailDialog",
    mixins: [RyouTableMixins],
    components: {
      UserChangeInformation,
      RyouBlackBtn,
    },
    data: () => ({
      dialog: false,
    }),
    props: {
      loadFlag: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    methods: {
      add() {
        this.open();
        var that = this;
        setTimeout(() => {
          that.$refs.modalForm.add();
        }, 10);
      },
        edit(record) {
        this.open();
        var that = this;
        setTimeout(() => {
          that.$refs.modalForm.edit(record);
        }, 10);
      },
      handleOk() {
        var that = this;
        setTimeout(() => {
          that.$refs.modalForm.handleOk();
        }, 10);
      },
      handleCancel() {
        this.close();
        var that = this;
        setTimeout(() => {
          that.$refs.modalForm.open();
        }, 10);
      },
      modalFormOk() {
        this.$emit("closeDialog");
        this.handleCancel();
      },
      close() {
        this.dialog = false;
      },
      open() {
        this.dialog = true;
      },
    },
  };
</script>
<style scoped>
  .rowBtn {
    width: 99%;
    padding-bottom: 20px;
  }
</style>